
// ! rename the function to align with the widget name
export const dataCallToAction = () => {
    const el = document.querySelector('.curious-data-call-to-action');
    if (!el) return;

    // ------------------------------------------------------------

   

    // ------------------------------------------------------------
    // ! Remember to call this function in the main script file: /site/src/js/site.js

}

